/*
 * Venuu-branded Checkbox element with larger touch area.
 *
 * Example usage:
 *
 * <Checkbox
 *   name="Some option name"
 *   inputProps={{
 *     name: 'catering[option_name]',
 *     onChange: (event) => { alert(event.target.value) }
 *   }}
 * />
 *
 */

import cx from 'classnames';
import type { InputHTMLAttributes, ReactElement } from 'react';
import styles from './Checkbox.module.scss';
import FontAwesomeIcon, {
  regularCheck
} from 'common/components/FontAwesomeIcon';

type Props = {
  name: string;
  verticalAlign?: 'default' | 'middle';
  inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;
};

export function Checkbox({
  name,
  verticalAlign = 'default',
  inputProps
}: Props): ReactElement {
  return (
    <label
      className={cx({
        [styles.label]: true,
        [styles.verticalAlignMiddle]: verticalAlign === 'middle'
      })}
    >
      <input {...inputProps} type="checkbox" />
      <FontAwesomeIcon
        className={cx({
          [styles.icon]: true,
          [styles.verticalAlignMiddle]: verticalAlign === 'middle'
        })}
        icon={regularCheck}
      />
      <span className={styles.labelText}>{name}</span>
    </label>
  );
}
